<template>
  <div >
    <my-dialog :show="isOpen" @cancel="cancelDia">
      <div style="padding: 10px 0">

        <div  >
            <div class="total_table">
              <div class="wind" style="width: 450px">
                <div class="wind-top" style="font-size: 14px;font-weight: bold">
                    亚马逊FBA物流参考报价
                </div>
                <div class="wind-item" v-for="(item, index) in wind" :key="index">
                  <div class="wind-item__name">
                    {{ item.name }}：
                  </div>
                  <el-input 
                  v-if="item.type === 'input'" 
                  v-model="item.value" 
                  :disabled="item.disabled" 
                  size="mini" 
                  :placeholder="item.pla"
                  @focus="focusPlace(index)"
                  :style="{'width':item.width}"
                  :suffix-icon="item.icon">
                    <template slot="append" v-if="item.append">{{ item.append }}</template>
                  </el-input>
                  <el-select v-else-if="item.type === 'select'" v-model="item.value" :disabled="item.disabled" size="mini" :style="{'width':item.width}">
                    <el-option
                      v-for="item1 in item.options"
                      :key="item1.value"
                      :label="item1.label"
                      :value="item1.value">
                    </el-option>
                  </el-select>
                  <div v-else-if="item.type === 'more'" >
                    <div style="display: inline-block"  v-for="(item1, index1) in item.item" :key="index1">
                      <el-input
                      v-if="item1.type === 'input'"
                      v-model="item1.value"
                      :placeholder="item1.pla"
                      size="mini"
                      :style="{'width':item1.width}"
                      style="margin: 0 8px 0 0">
                        <template slot="append" v-if="item1.append">{{ item1.append }}</template>
                      </el-input>
                      <el-button
                      v-else-if="item1.type === 'button'" size="mini" :style="{'width':item1.width}">
                        {{ item1.value }}
                      </el-button>
                    </div>
                    
                  </div>
                </div>
                <div class="wind-btn">
                  <div class="btn" @click="textClick">清空输入内容</div>
                  <div class="btn" @click="textClick">清空输入内容</div>
                </div>
              </div>
              <div class="normal_table " style="width: 600px">
                <div class="my_table">
                  <div class="no_change_table t_head" style="width: 250px">
                    <div class="item_border item5">
                      <div>选择</div>
                    </div>
                    <div class="item_border item4">
                      <div>运输方式</div>
                    </div>
                    
                  </div>
                  <div class="normal_data t_head" style="width: 750px;left: 250px">
                    <div class="item_border item2">
                      <div>头程跨境物流</div>
                    </div>
                    <div class="item_border item2">
                      <div>尾程当地物流</div>
                    </div>
                    <div class="item_border item2">
                      <div>商品入口关税</div>
                      <div>(包税/不包税)</div>
                    </div>
                    <div class="item_border item2">
                      <div>运输时间</div>
                      <div>(工作天)</div>
                    </div>
                    <div class="item_border item1">
                      <div>总运费</div>
                      <div>(￥)</div>
                    </div>
                  </div>
                </div>
                <div class="my_table" style="height: 45px" v-for="(item,index) in 4" :key="index">
                  <div class="no_change_table " style="width: 250px">
                    <div class="item_border item5">
                      <!-- <div>承运商/货代</div> -->
                      <input type="radio">
                    </div>
                    <div class="item_border item2">
                      <!-- <div v-if="index === 2" class="small-click" style="margin:0">自己送仓</div> -->
                      <div >Air Freight Direct</div>
                    </div>
                    
                  </div>
                  <div class="normal_data " style="width: 750px;left: 250px;height: 45px">
                    <div class="item_border item2">
                      <div v-if="index === 2">全球快递专线</div>
                      <div v-else>国际快递专线</div>
                    </div>
                    <div class="item_border item2">
                      <div>DHL当地派送</div>
                    </div>
                    <div class="item_border item2">
                      <div>Yes</div>
                    </div>
                    <div class="item_border item2">
                    <div>3~5</div>
                    </div>
                    <div class="item_border item1">
                      <div></div>
                    </div>
                  </div>
                </div>
                <div style="float: right;margin: 10px 0;">
                  <button class="select_button" @click="textClick">确认</button>
                </div>
              </div>
            </div>
            
          </div>
      </div>
    </my-dialog>
  </div>
  
</template>

<script>
import Dialog from "@/components/common/Dialog"
export default {
components: {
  'my-dialog': Dialog
},
data(){
  return{
    isOpen: true,
    wind:{
      country:{
        name: '收件国家/地区',
        type: 'select',
        disabled: true,
        value:0 ,
        width: '307px',
        options:[
          {
            value:0,
            label:'United States'
          }
        ]
      },
      place:{
        name: '送仓地址',
        type: 'select',
        disabled: true,
        pla:'请选择亚马逊仓库地址',
        value:'',
        width: '307px',
        options:[],
      },
      cpzk:{
        name: '产品状况',
        type: 'select',
        disabled: true,
        pla:'产品状况',
        value:'',
        width: '307px',
        options:[],
      },
      wxcc:{
        name: '外箱尺寸(cm)',
        type: 'more',
        item:{
          length:{
            type:'input',
            value:'',
            pla:'长',
            width:'97px'
          },
          width:{
            type:'input',
            value:'',
            pla:'宽',
            width:'97px'
          },
          height:{
            type:'input',
            value:'',
            pla:'高',
            width:'97px'
          }
        }
      },
      yxsl:{
        name: '1箱数量/重量',
        type: 'more',
        item:{
          number:{
            type:'input',
            value:'',
            pla:'',
            width:'150px',
            append:'(套/箱)'
          },
          weight:{
            type:'input',
            value:'',
            pla:'',
            width:'150px',
            append:'(Kg/箱)'
          },
        }
      },
      placeTwo:{
        name: '总箱数',
        type: 'input',
        disabled: false,
        value:'',
        width: '308px',
        append:'(箱)'
        // icon:'el-icon-arrow-down'
      },
      method:{
        name: '寄件方式',
        type: 'more',
        item:{
          number:{
            type:'input',
            value:'',
            pla:'货运起运地，如',
            width:'208px',
          },
          weight:{
            type:'button',
            value:'上门收件',
            pla:'',
            width:'92px',
          },
        }
      }
    },
  }
},
methods:{
  cancelDia(){
    this.isOpen = false
  },
  textClick(){
    this.$message.warning('功能处理中')
  },
}

}
</script>

<style lang="scss">
.wind{
  .el-input-group__append{
    border-radius: 0 !important;
  }
  .el-input-group__append, .el-input-group__prepend{
    width: 60px;
    text-align: center;
    padding: 0;
    background: #FFF;
  }
}

</style>
<style lang="scss" scoped>
  .wind{
    color: #fff;
    background-color: #09305b;
    padding: 0 0 20px 0;
    // background-color: #99dcf3;
    &-top{
      background-color: #09305b;
      // background-color: #00a0c7;
      padding: 10px 10px;
      margin: 0 0 3px 0;
    }
    &-item{
      display: flex;
      align-items: center;
      padding: 2.5px 15px;
      &__name{
        width: 100px;
        font-size: 13px;
      }
    }
    &-btn{
      display: flex;
      justify-content: flex-end;
      padding: 0px 27px;
      margin: 3px 0 0 0;
      .btn{
        background-color: #2085e7;
        padding: 6px 10px;
        margin: 0 0 0 5px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
  .select_button{
    
    padding: 8px 20px;
    // border-radius: 5px;
    margin-left: 5px;
    border: none;
    outline: none;
    background-color: #00a0c7;
    color: white;
  }

  .select_button:hover{
    cursor: pointer;
    opacity: .8;
  }
.total_table{
    display: flex;
    // height: 550px;
    position: relative;
  }

  .normal_table{
    width: 100%;
  }

  .my_table{
    display: flex;
    height: 50px;
    color: black;
    width: 100%;
  }

  .no_change_table{
    display: flex;
    // width: 300px;
    flex: 3;
    text-align: center;
    text-overflow: ellipsis;
    border-bottom: 1px solid #e6e6e6;
  }

  .normal_data{
    display: flex;
    /*flex: 18.4;*/
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
    height: 50px;
    margin: auto;
    text-overflow: ellipsis;
    background-color: #fff;
    flex: 8;
    backface-visibility: hidden;
    overflow: hidden;
  }

  .t_head{
    background-color: #e6f7ff;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    font-size: 8px;
  }

  .grey_head{
    background-color: rgb(245, 245, 245);
    color: #808080;
    font-weight: bold;
    // border-top: 1px solid #e6e6e6;
    // border-bottom: 1px solid #e6e6e6;
    font-size: 8px;
  }

  .other_bgc{
    background-color: #c8ecff;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    font-size: 8px;
  }

  .item_border{
    position: relative;
    text-align: center;
    margin: auto;
    text-overflow: ellipsis;
  }

  .item1{
    flex: 1;
  }

  .item2{
    flex: 1.5;
  }

  .item3{
    flex: 2.2;
  }

  .item4{
    flex: 1.8;
  }

  .item5{
    flex: 0.6;
  }

  .item6{
    flex: 3;
  }

  .item3 span{
    margin: 0 3px;
    color: #1890ff;
  }

  .item3 span:hover{
    opacity: .8;
    cursor: pointer;
  }

</style>